import type { BusinessPhoto } from "common/types/venue";

/**
 * Photos the Photos tab can show: not Google Maps imagery, and linked to a
 * review, review detail or review level. Legacy uploads linked to none of
 * these (review_id 0) never appear in the tab, so they aren't counted.
 */
export function countVenuePhotos(photos: BusinessPhoto[] | undefined): number {
  return (photos ?? []).filter(
    (p) =>
      p.photoType !== "Google Maps" &&
      ((p.reviewId ?? 0) > 0 || !!p.reviewDetailId || !!p.reviewLevelId),
  ).length;
}
